module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image-ctn"
  }, [_c('div', {
    staticClass: "image"
  }, [_c('svg', {
    staticClass: "shape-mask",
    attrs: {
      "viewBox": "0 0 400 500",
      "preserveAspectRatio": "none"
    }
  }, [_c('path', {
    staticStyle: {
      "fill": "#FDFAF5"
    },
    attrs: {
      "d": "M400,460c0,0-17,40-106,40s-97-40-187-40S0,490,0,490V0c0,0,18,0,112,0s100,0,186,0s102,0,102,0V460z"
    }
  })]), _c('transition', {
    attrs: {
      "name": "shape-mask",
      "mode": "out-in",
      "css": false,
      "appear": "appear"
    },
    on: {
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, [_c('div', {
    key: _vm.image,
    staticClass: "img-wrap"
  }, [(_vm.image !== null) ? _c('img', {
    key: _vm.image,
    attrs: {
      "srcset": _vm.image.srcSet,
      "src": _vm.image.images ? _vm.image.images[2].path : _vm.image.src
    }
  }) : _vm._e(), (_vm.image !== null && _vm.image.center !== undefined) ? _c('gmap-map', {
    key: _vm.image,
    ref: "gmap",
    attrs: {
      "center": _vm.image.center,
      "zoom": 12,
      "options": _vm.image.options,
      "gestureHandling": "cooperative"
    }
  }, [_c('gmap-marker', {
    key: _vm.image,
    attrs: {
      "position": _vm.image.center,
      "icon": " ",
      "label": _vm.image.marker
    }
  })], 1) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "clear"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-741bccff"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Image.vue
// module id = 432
// module chunks = 1